<template>
  <div class="flex gap-2">
    <div class="flex flex-col items-center gap-1 h-full pt-1">
      <div
        v-if="isFirst"
        class="rounded-full h-4 w-4 flex-shrink-0 bg-light-purple-100 flex items-center justify-center"
      >
        <div class="rounded-full h-2 w-2 flex-shrink-0 bg-light-purple"></div>
      </div>
      <div
        v-else
        class="rounded-full h-4 w-4 flex-shrink-0 flex items-center justify-center"
      >
        <div class="rounded-full h-2 w-2 flex-shrink-0 bg-slate-500"></div>
      </div>
      <div
        v-if="!isLast"
        class="w-0.5 rounded bg-slate-400"
        :style="{ height: lineHeight }"
      ></div>
    </div>
    <div :id="`activity_${activity.id}`" class="flex flex-col">
      <div class="mb-1">
        <BlTextBody2 :text="createdAt" />
      </div>
      <div class="mb-3">
        <BlTextBody2 class="text-slate-1000" :text="title" />
      </div>
      <div v-if="activity.current_data" class="mb-3 flex flex-col gap-1">
        <BlTextBody2
          v-if="activity.previous_data"
          class="line-through"
          :text="activity.previous_data"
        />
        <BlTextBody2 :text="activity.current_data" />
      </div>
      <div v-if="complementaryInformation" class="mb-3 flex flex-col gap-1">
        <BlTextBody2 :text="complementaryInformation" />
      </div>
      <div v-if="activity.current_status" class="mb-3 flex items-center gap-2">
        <div v-if="activity.previous_status" class="flex items-center gap-2">
          <BlChip :chip="activity.previous_status" />
          <BlIcon icon="arrow-right" color="slate-6" class="h-4 w-4" />
        </div>
        <BlChip :chip="activity.current_status" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import BlTextBody2 from "./BlTextBody2.vue";
import BlChip from "./BlChip.vue";
import BlIcon from "./BlIcon.vue";

export default {
  name: "BlActivity",
  components: { BlTextBody2, BlChip, BlIcon },
  props: {
    activity: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: true
    },
    isLast: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      lineHeight: "0px"
    };
  },
  mounted() {
    setTimeout(() => {
      const el = document.getElementById(`activity_${this.activity.id}`);
      if (el) this.lineHeight = `${el.offsetHeight}px`;
    }, 10);
  },
  computed: {
    /*
      SVOA (Subject + Verb + Object + Adverb/Complementary information)
      docs: https://www.notion.so/simpul/d977adaa317d408a8af6eb6e0a3c42bb?v=dadbf44463ae4dbc95a9ed12eb7de0ae
    */
    isUseComplementary() {
      /*
        Complementary case
        key   : Subject, Object, Receive
        ---------------------------------------------------------------
        case 1: User, Instruction, Prospect
        case 2: User, ProspectForm, Prospect
        case 3: User, Prospect, null
        case 4: Prospect, ProspectForm, Prospect
        ---------------------------------------------------------------
        return SVA (Subject + Verb + Adverb/Complementary information)
      */
      const {
        subjectable_type: subjectType,
        objectable_type: objectType,
        receiverable_type: receiveType
      } = this.activity;

      const cases = [
        ["User", "Instruction", "Prospect"],
        ["User", "ProspectForm", "Prospect"],
        ["User", "ProspectForm", null],
        ["Prospect", "ProspectForm", "Prospect"]
      ];

      return cases
        .map(i => {
          return (
            subjectType === i[0] && objectType === i[1] && receiveType === i[2]
          );
        })
        .includes(true);
    },
    createdAt() {
      return moment(this.activity.created_at).format("DD MMM YYYY HH:mm");
    },
    title() {
      // Preparation
      const {
        subjectable_type: subjectType,
        objectable_type: objectType,
        receiverable_type: receiveType
      } = this.activity;

      // Subject
      const subject = this.activity.subjectable_string
        ? this.activity.subjectable_string
        : `${subjectType} ID ${this.activity.subjectable_id}`;
      // Verb
      const verb = `${this.activity.verb}`;
      // Object
      const receiveString = `${receiveType} ID ${this.activity.receiverable_id}`;
      const objectString = `${objectType} ID ${this.activity.objectable_id}`;
      let object = this.activity.receiverable_type
        ? receiveString
        : objectString;

      // Complementary case
      if (this.isUseComplementary) {
        object = this.activity.complementary_information;
      }

      let text = `${subject} ${verb} ${object}`;
      return text;
    },
    complementaryInformation() {
      if (!this.activity.complementary_information) {
        return "";
      }
      // Complementary case
      if (this.isUseComplementary) {
        return "";
      }
      return `Reason: ${this.activity.complementary_information}`;
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/BlActivity.vue